import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError, AxiosResponse, AxiosResponseHeaders } from "axios";
import { Thunk } from "../../store";
import {
  BackendCasoArchivadoPorIdContext,
  getCurrentDomain,
} from "../../../apis/backend/Api";
import mock_Json from "../../../dataJson/casoArchivadoContext.json";
import { formatearMensajeBackend } from "../../../apis/helper/helperApi";
import { TypeStatus } from "../../helpers/constantes";

interface State {
  casoArchivadoPorIdContext: any[];
  storageId_string: string;
  tiempoEstim_ref: string;
  tiempo_ref: string;
  serviceRequest_ref_link: string;
  status: TypeStatus;
  isLoading: boolean;
  Success: boolean;
  Mensaje: string | null;
  error: string | null;
}

const initialState: State = {
  casoArchivadoPorIdContext: [],
  status: "idle",
  isLoading: false,
  Success: false,
  Mensaje: "",
  error: null,
  storageId_string: "",
  tiempoEstim_ref: "",
  tiempo_ref: "",
  serviceRequest_ref_link: "",
};
interface defaultResponse {
  data: any;
  status: number;
  statusText: string;
  headers: AxiosResponseHeaders | {};
  config: any;
  request?: any;
}
const defaultResp: defaultResponse = {
  data: undefined,
  status: 0,
  statusText: "",
  headers: {},
  config: undefined,
};
const casoArchivadoPorIdContextSlice = createSlice({
  name: "casoArchivadoPorIdContext",
  initialState,
  reducers: {
    setCasoArchivadoPorIdContext: (state, action: PayloadAction<any[]>) => {
      state.casoArchivadoPorIdContext = action.payload;
    },
    getCasoArchivadoPorIdContext: (state, action: PayloadAction<any[]>) => {
      state.casoArchivadoPorIdContext = action.payload;
    },
    setClearCasoArchivadoPorIdContext: (
      state,
      action: PayloadAction<any[]>,
    ) => {
      state = initialState;
    },
    setStorageId: (state, action: PayloadAction<string>) => {
      state.storageId_string = action.payload;
    },
    setTiempoEstimRef: (state, action: PayloadAction<string>) => {
      state.tiempoEstim_ref = action.payload;
    },
    setTiempoRef: (state, action: PayloadAction<string>) => {
      state.tiempo_ref = action.payload;
    },
    setServiceRequest_ref_link: (state, action: PayloadAction<string>) => {
      state.serviceRequest_ref_link = action.payload;
    },

    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStatus: (state, action: PayloadAction<TypeStatus>) => {
      state.status = action.payload;
    },
    setResult: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.Success = action.payload;
    },
    setMensaje: (state, action: PayloadAction<string>) => {
      state.Mensaje = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
});
export const setBackendCasoArchivadoPorIdContext =
  (caseId: number): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));
    try {
      const response: AxiosResponse =
        await BackendCasoArchivadoPorIdContext(caseId);

      const isError =
        response.data?.Success === false ||
        (response.data?.ResultadoSolicitud !== undefined &&
          response.data?.ResultadoSolicitud !== 200);

      if (isError) {
        dispatch(setIsLoading(false));
        dispatch(setStatus("failed"));
        dispatch(setSuccess(false));
      } else {
        dispatch(setCasoArchivadoPorIdContext(response.data.Data));
        if (response.data.Data && response.data.Data[0]) {
          dispatch(
            setServiceRequest_ref_link(
              response.data.Data[0].serviceRequest_ref?.link,
            ),
          );
          dispatch(
            setStorageId(response.data.Data[0].serviceRequest_ref?.storageId),
          );
          dispatch(setTiempoEstimRef(response.data.Data[0].tiempoEstim_ref?.link));
          dispatch(setTiempoRef(response.data.Data[0].tiempo_ref?.link));
        }
        dispatch(setIsLoading(false));
        dispatch(setStatus("succeeded"));
        dispatch(setSuccess(true));
      }
      dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setSuccess(false));
      dispatch(setStatus("failed"));

      if (error.response?.status === 401) {
        dispatch(setStatus("noAutorice"));
        dispatch(
          setMensaje(
            formatearMensajeBackend(
              "Tu sesión ha expirado. Vuelve a iniciar sesión",
            ),
          ),
        );
      } else if (error.response) {
        // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
        console.error(
          "Error de servidor:",
          error.response.status,
          error.response.data,
        );

        const errorData = error.response.data;
        const mensajeBackend = errorData?.Mensaje;
        const resultadoSolicitud = errorData?.ResultadoSolicitud;

        // Si el backend devolvió un objeto de respuesta con ResultadoSolicitud !== 200 o Success === false
        if (
          mensajeBackend &&
          (resultadoSolicitud !== 200 || errorData?.Success === false)
        ) {
          dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
        } else {
          dispatch(
            setMensaje(
              `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
            ),
          );
        }
      } else if (error.request) {
        // La solicitud fue enviada, pero no hubo respuesta
        console.error("Error de conexión:", error.message);
        dispatch(
          setMensaje(
            "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
          ),
        );
      } else {
        // Es un error de red (DNS, etc.) o un error de configuración de la solicitud
        console.error("Error de red o solicitud:", error.message);
        dispatch(
          setMensaje(
            "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
          ),
        );
      }
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));

      if (getCurrentDomain() === "localhost") {
        dispatch(setIsLoading(true));
        let response: AxiosResponse = defaultResp;
        response.data = mock_Json;

        const mockData: any = mock_Json;
        const isErrorMock =
          mockData?.Success === false ||
          (mockData?.ResultadoSolicitud !== undefined &&
            mockData?.ResultadoSolicitud !== 200);

        if (isErrorMock) {
          dispatch(setIsLoading(false));
          dispatch(setStatus("failed"));
          dispatch(setSuccess(false));
        } else {
          dispatch(setCasoArchivadoPorIdContext(response.data.Data));
          if (response.data.Data && response.data.Data[0]) {
            dispatch(
              setServiceRequest_ref_link(
                response.data.Data[0].serviceRequest_ref?.link,
              ),
            );
            dispatch(
              setStorageId(response.data.Data[0].serviceRequest_ref?.storageId),
            );
            dispatch(setTiempoEstimRef(response.data.Data[0].tiempoEstim_ref?.link));
            dispatch(setTiempoRef(response.data.Data[0].tiempo_ref?.link));
          }
          dispatch(setIsLoading(false));
          dispatch(setStatus("succeeded"));
          dispatch(setSuccess(true));
        }
        dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
        const mock401 = await import("../../../dataJson/401.json");
        if (mock401.status === 401) {
          dispatch(setStatus("noAutorice"));
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                "Tu sesión ha expirado. Vuelve a iniciar sesión",
              ),
            ),
          );
        }
      }
    }
  };

export const setBackendClearCasoArchivadoPorIdContext =
  (): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));
    try {
      let response: AxiosResponse = defaultResp;
      dispatch(setCasoArchivadoPorIdContext([]));
      dispatch(setIsLoading(false));
      dispatch(setStatus("idle"));
      dispatch(setSuccess(false));
      dispatch(setMensaje(""));
      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
    }
  };

export const {
  setCasoArchivadoPorIdContext,
  setStorageId,
  setTiempoEstimRef,
  setTiempoRef,
  setServiceRequest_ref_link,
  getCasoArchivadoPorIdContext,
  setClearCasoArchivadoPorIdContext,
  setIsLoading,
  setStatus,
  setResult,
  setSuccess,
  setMensaje,
  setError,
} = casoArchivadoPorIdContextSlice.actions;

export default casoArchivadoPorIdContextSlice.reducer;
